import DataExportsTemplate from '../../components/5templates/DataExportsTemplate'

const DataExport = () => {

    return (
        <DataExportsTemplate />
    )
}

export default DataExport